import axios from "axios";
import { encode } from "base-64";
const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL || "/api/";

// axios.defaults.headers.post['Access-Control-Allow-Headers'] = 'Content-Type, Authorization';
// axios.defaults.headers.post['Cache-Control'] = 'no-cache';

// Generated by GitHub Copilot - Track pending requests to allow route-change cancellation
const pendingControllers = new Set();

/**
 * Cancels all in-flight API requests. Call this on route change.
 */
export const cancelPendingRequests = () => {
  pendingControllers.forEach((controller) => controller.abort());
  pendingControllers.clear();
};

export const api = axios.create({
  baseURL: REACT_APP_BASE_URL,
  withCredentials: true
});

// Generated by GitHub Copilot - Attach AbortController to every request and clean up on completion
api.interceptors.request.use(
  (config) => {
    const controller = new AbortController();
    config.signal = controller.signal;
    pendingControllers.add(controller);

    console.log("API Request:", {
      method: config.method,
      url: config.url,
      withCredentials: config.withCredentials,
      headersKeys: Object.keys(config.headers),
      cookieHeader: config.headers.Cookie || "NO COOKIE HEADER",
    });
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => {
    if (response.config.signal) {
      // Remove the controller associated with this request
      pendingControllers.forEach((controller) => {
        if (controller.signal === response.config.signal) {
          pendingControllers.delete(controller);
        }
      });
    }
    console.log("API Response:", {
      url: response.config.url,
      status: response.status,
      dataLength: response.data ? (typeof response.data === 'string' ? response.data.length : JSON.stringify(response.data).length) : 0,
      data: response.data,
    });
    return response;
  },
  (error) => {
    if (axios.isCancel(error)) {
      // Silently ignore cancelled requests - this is expected on route change
      return new Promise(() => {});
    }
    console.error("API Error:", {
      url: error.config?.url,
      status: error.response?.status,
      data: error.response?.data,
    });
    return Promise.reject(error);
  }
);

export const statusApi = axios.create({
  baseURL: REACT_APP_BASE_URL,
  withCredentials: true,
  headers: {
    Accept: "application/json, text/plain, */*",
    "Accept-Language": "pt,en-US;q=0.9,en;q=0.8",
    "Content-Type": "application/x-www-form-urlencoded",
  },
});

export const returnToken = (callback) => {
  return api
  .post(REACT_APP_BASE_URL + "core/ajax/manager.users", {
    type: 'returnToken',
  })
  .then(function (res) {
    callback(res.value)
  })
  .catch(function (error) {
    console.log(error);
  });
}

export const getFilter = (authx, type, setName) => {
  // Generated by GitHub Copilot
  console.log("getFilter called with:", { authx, type });
  
  api
    .post("core/ajax/reports", {
      authx: authx,
      type: type,
    })
    .then(function (res) {
      console.log("getFilter raw response:", { 
        type, 
        statusCode: res.status,
        headers: res.headers,
        dataType: typeof res.data,
        dataLength: res.data ? (typeof res.data === 'string' ? res.data.length : Object.keys(res.data).length) : 0,
        data: res.data 
      });
      
      // Handle case where response is empty or not an array
      if (!res.data || (Array.isArray(res.data) && res.data.length === 0)) {
        console.warn(`getFilter returned empty data for type: ${type}`, { raw: JSON.stringify(res.data) });
        setName([]);
        return;
      }

      // Ensure res.data is an array
      const dataArray = Array.isArray(res.data) ? res.data : [];
      console.log("getFilter array count:", { type, count: dataArray.length });
      
      setName(
        dataArray.map((e) => {
          var arr = [];

          for (const [, value] of Object.entries(e)) {
            arr.push(value);
          }
          return arr[1]
            ? { label: arr[1], value: arr[0] }
            : { label: arr[0], value: arr[0] };
        })
      );
    })
    .catch(function (error) {
      console.error("getFilter error:", { type, error: error.message, response: error.response?.data });
    });
};
